// extracted by mini-css-extract-plugin
module.exports = {"textEditor":"Editor_textEditor__3CUNQ","editorScroll":"Editor_editorScroll__2TpZZ"};